import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Logo from "../assets/nutrackx.png";
import moment from "moment";

const generatePDF = async (singleEmployeeAttendance, name, fromDate, toDate) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const formatFromDate = moment(fromDate).format('DD-MMM-YYYY')
  const formatToDate = moment(toDate).format('DD-MMM-YYYY')
  const imgWidth = 210;
  const pageHeight = 297;
  const headerHeight = 20;
  const footerHeight = 10;

  // Load and add logo
  const logo = new Image();
  logo.src = Logo;

  await new Promise((resolve) => {
    logo.onload = resolve;
  });

  pdf.addImage(logo, "PNG", 4, -5, 40, 30);

  // Title
  pdf.setFontSize(16);
  pdf.text("Employee Attendance Sheet", imgWidth / 2, 13, { align: "center" });
  pdf.setFontSize(10);
  pdf.text(`(${formatFromDate} - ${formatToDate})`, imgWidth - 20, 13, { align: "right" });

  // Header underline
  pdf.setLineWidth(0.5);
  pdf.setDrawColor(0, 128, 0);
  pdf.line(10, headerHeight, imgWidth - 10, headerHeight);

  let startY = headerHeight + 5;

  // Validate data
  if (!singleEmployeeAttendance || typeof singleEmployeeAttendance !== "object") {
    console.error("Invalid singleEmployeeAttendance data:", singleEmployeeAttendance);
    pdf.text("Error: No attendance data available", 10, startY + 10);
    pdf.save(`${name === "All" ? "All" : name}.pdf`);
    return;
  }

  Object.keys(singleEmployeeAttendance).forEach((dept) => {
    // Department heading
    pdf.setFontSize(14);
    pdf.setTextColor(255, 255, 255);
    pdf.setFillColor(128, 0, 128); // Purple
    pdf.rect(10, startY, imgWidth - 20, 8, "F");
    pdf.text(dept.toUpperCase(), imgWidth / 2, startY + 6, { align: "center" });
    startY += 10;

    singleEmployeeAttendance[dept].forEach((employee) => {
      // Employee name row
      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.setFillColor("#D1D5DB"); // Light gray
      pdf.rect(10, startY, imgWidth - 20, 8, "F");
      pdf.text(employee.firstname || "Unknown", 15, startY + 6);
      startY += 10;

      // Build table data
      const tableData = employee.attendanceData.map((attendance) => {
        const remark =
          attendance.remark !== "Annual Leave" &&
            attendance.remark !== "Sick Leave" &&
            attendance.remark !== "Absent" &&
            attendance.remark !== "present" &&
            attendance.remark !== "SATURDAY" &&
            attendance.remark !== "SUNDAY"
            ? attendance.remark
            : "";
        return [
          `${attendance.date} ${remark ? `(${remark})` : ""}`,
          attendance.entryTime || attendance.remark,
          attendance.leavingTime ||
          (attendance.leaveRemark && attendance.remark !== "Absent"
            ? attendance.leaveRemark.slice(0, 20) + "..."
            : ""),
          // `${attendance.workType}(${attendance?.remoteReason})`,
          `${attendance.workType ? attendance.workType : ""} ${attendance.remoteReason ? `(${attendance.remoteReason.slice(0, 20) + "..."})` : ""}`,
          attendance.hours || "",
          attendance.totalHours || "",
        ];
      });

      // Totals
      let totalHours = 0;
      let totalMinutes = 0;
      let totalLate = 0;
      let totalAbsent = 0;
      let totalPresent = 0;
      let totalHoliday = 0;
      let totalLeave = 0;
      let totalDays = 0;
      let RemoteDays = 0;
      let onsiteDays = 0;

      employee.attendanceData.forEach((attendance) => {
        if (attendance.totalHours) {
          const [hours, minutes] = (attendance.totalHours || "0:0").split(":").map(Number);
          totalHours += hours || 0;
          totalMinutes += minutes || 0;
        }
        if (attendance.workType === "Remote") RemoteDays++;
        if (attendance.workType === "Onsite") onsiteDays++;
        if (attendance.late === "Late") totalLate++;
        if (attendance.entryTime) totalPresent++;
        if (attendance.dayType === "Absent") totalAbsent++;
        if (attendance.dayType === "Leave") totalLeave++;
        if (
          !attendance.entryTime &&
          attendance.dayType === "Holiday" &&
          attendance.remark !== "SATURDAY" &&
          attendance.remark !== "SUNDAY"
        ) {
          totalHoliday++;
        }
        if (attendance?.entryTime || (attendance.dayType !== "Weekend" &&
          attendance.remark !== "SATURDAY" &&
          attendance.remark !== "SUNDAY")) {
          totalDays += 1
        }
      });
      // console.log("totalPresent", totalPresent)

      totalHours += Math.floor(totalMinutes / 60);
      totalMinutes %= 60;
      const formattedMinutes = String(totalMinutes).padStart(2, "0");
      // Push totals
      tableData.push([
        `TDays (${totalDays}) TPresent (${totalPresent})`,
        `TAbsents(${totalAbsent}) `,
        `Remote(${RemoteDays}) Onsite (${onsiteDays})`,
        `TLates (${totalLate}) TLeaves (${totalLeave})`,
        `Holiday(${totalHoliday})`,
        `THours ${totalHours}:${formattedMinutes}`,
      ]);

      // Add table
      autoTable(pdf, {
        startY: startY,
        head: [["Date", "Entry Time", "Leaving Time", "WorkType", "Hours", "Total Hours"]],
        body: tableData,
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 2,
          textColor: [0, 0, 0],
          fillColor: "#D1D5DB",
          minCellHeight: 8,
        },
        headStyles: {
          fillColor: ["#D1D5DB"], // Light gray
          textColor: [0, 0, 0],
          fontSize: 11,
        },
        columnStyles: {
          0: { cellWidth: 45 }, // Date
          1: { cellWidth: 25 }, // Entry Time
          2: { cellWidth: 40 }, // Leaving Time
          3: { cellWidth: 40 }, // WorkType
          4: { cellWidth: 25 }, // Hours
          5: { cellWidth: 20 },
        },
        margin: { left: 10, right: 10 },
        // margin: { top: 15, right: 10, bottom: 15, left: 10 },
        didParseCell: function (data) {
          const rowIndex = data.row.index;
          const isHeader = data.section === "head";
          const isTotal = rowIndex === tableData.length - 1;

          if (isHeader || isTotal) {
            data.cell.styles.fillColor = [200, 200, 200];
            return;
          }

          const attendance = employee.attendanceData?.[rowIndex];
          if (!attendance) return;

          if (attendance.remark === "SUNDAY" || attendance.remark === "SATURDAY") {
            data.cell.styles.fillColor = ["#D1D5DB"]; // Light blue
          } else if (
            attendance.dayType === "Holiday" ||
            attendance.remark?.toLowerCase().includes("ed")
          ) {
            data.cell.styles.fillColor = ["#e3f7ea"]; // Light green
          } else if (attendance.dayType === "Absent") {
            data.cell.styles.fillColor = ["#f9b8b8"]; // Light red
          } else if (attendance.late === "Late") {
            data.cell.styles.fillColor = ["#fff"]; // Light yellow
          } else if (attendance.dayType === "Leave") {
            data.cell.styles.fillColor = ["#ddbedd"]; // Light purple
          } else {
            data.cell.styles.fillColor = [255, 255, 255]; // White
          }
        },
      });

      startY = pdf.lastAutoTable.finalY + 10;
      if (startY > pageHeight - footerHeight - 10) {
        pdf.addPage();
        startY = 10;
      }
    });
  });

  // Footer
  const totalPages = pdf.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    const pageText = `Page ${i} of ${totalPages}`;
    const textWidth = pdf.getTextWidth(pageText);
    pdf.text(pageText, imgWidth - textWidth - 10, pageHeight - 5);
    pdf.text(
      `Printed On: ${new Date().toLocaleDateString("en-GB")} ${new Date().toLocaleTimeString()}`,
      10,
      pageHeight - 5
    );
  }

  pdf.save(`${name === "All" ? "All" : name}.pdf`);
};

export default generatePDF;
